import React from "react";

import { Button, Popover } from "antd";

import "./SetUnitsToDefaultConfirmPopover.css";

function SetUnitsToDefaultConfirmPopover({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
  loading,
  children,
}) {
  const content = (
    <div className="SetUnitsToDefaultConfirmPopover__Content">
      <p className="SetUnitsToDefaultConfirmPopover__Message">
        Would you like to restore all result and spec units to their original default values?
      </p>
      <div className="SetUnitsToDefaultConfirmPopover__Actions">
        <Button
          type="default"
          className="SetUnitsToDefaultConfirmPopover__Btn"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          className="SetUnitsToDefaultConfirmPopover__Btn"
          onClick={onConfirm}
          loading={loading}
        >
          Confirm
        </Button>
      </div>
    </div>
  );

  return (
    <Popover
      open={open}
      onOpenChange={onOpenChange}
      content={content}
      trigger="click"
      placement="bottomLeft"
      arrow={{ pointAtCenter: true }}
      classNames={{ root: "SetUnitsToDefaultConfirmPopover" }}
    >
      {children}
    </Popover>
  );
}

export default SetUnitsToDefaultConfirmPopover;
